import * as Sentry from '@sentry/browser';
import { createAttendee } from './utils-module.js';
import {
  isNeedToShowPrivacy,
  initRegForm,
  getErrorRegFallBecauseOfAttendeeNull,
  initPrivacyPolicyLink,
  prepareRegPage,
} from './registration/index.js';
import { assertPageParams, validationVariants, fetchData } from './page.js';
import { setBackground, setLogo } from './customizePage/registration.js';
import { redirectToPage } from './page-routes.js';
import multiAccounts from './multiAccounts/index.ts';
import { findAttendeeByUIDAndEventId } from '../../../packages/src/api/index.js';
import { calculateExpiredDate } from './multiAccounts/data.ts';
import { saveLocParams, initLoc, t, setTextToElement } from './localization.js';
import { initEventOrganisationDataStorage } from '../../../packages/src/eventOrganisationDataStorage.js';

const eventOrganisationDataStorage = initEventOrganisationDataStorage();
const { isSetUpEventName } = validationVariants;

const form = initRegForm();

async function init() {
  prepareRegPage();
  assertPageParams([isSetUpEventName]);

  initPrivacyPolicyLink();

  const event = await fetchData.event();

  if (!event) {
    Sentry.withScope(scope => {
      scope.setTag('module', 'registration');
      scope.setLevel('error');
      scope.setContext('localStorage', { eventName: localStorage.getItem('eventName') });
      Sentry.captureException(new Error('Event name is missing in localStorage'));
    });
  }

  const { opts } = event;

  saveLocParams({ orgId: event.organisation?.id, eventCode: event.name });
  await initLoc();

  if (event.organisation) {
    eventOrganisationDataStorage.storeEventOrganisationData(event.organisation);
  }

  setTextToElement('#createAtt', t('submit-registration-btn'));

  setLogo(opts.webappCustomLogoSrc);
  setBackground(opts.webappCustomBackgroundSrc);

  if (opts.webappIsEnabledSMS) {
    form.enablePhoneNumber(opts.webappSMSAgreement);
  }

  if (isNeedToShowPrivacy(opts)) {
    form.enableAgreePrivacy();
  }

  form.onSubmit(async ({ name, email, phoneNumber }) => {
    const { result: attendeeUid } = await createAttendee({
      eventCode: event.name,
      name,
      email,
      phoneNumber,
    });
    if (!attendeeUid) {
      alert(getErrorRegFallBecauseOfAttendeeNull({ canBeEmailConfirmationProblem: true }));
      return;
    }
    const { result: attendee } = await findAttendeeByUIDAndEventId(attendeeUid, event.id);
    multiAccounts.addAccount({
      attendeeUid,
      eventCode: event.name,
      eventLogo: opts.webappCustomLogoSrc,
      name,
      email,
      phoneNumber,
      regDate: attendee.created_date,
      expireDate: calculateExpiredDate(event, attendee),
    });
    multiAccounts.setCurrentAccount(0);
    redirectToPage.index({ rawSearch: window.location.search });
  });
}

document.addEventListener('DOMContentLoaded', init);
